<template>
  <div v-if="alertColor && metaDeadline.countdown">
    <b-tooltip type="is-dark" multilined class="time-response-alert">
      <template v-slot:content>
        <p
          style="width: 30rem; text-wrap: wrap; padding: 10px"
          v-html="
            'Time to First Response shows the remaining time to reply. It stays green for 48h-20h, turns yellow between 19h-6h, and is marked as high priority in red when under 6h.'
          "
        ></p>
      </template>
      <span class="circle-icon" :style="{ backgroundColor: alertColor }"></span>
      <span v-if="showDate" class="ml-2" :style="{ color: alertColor }">
        {{ remainingText }}
      </span>
    </b-tooltip>
  </div>
</template>

<script>
export default {
  name: "TimeResponseAlert",
  props: {
    created: String,
    metaDeadline: Object,
    showDate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      counterId: -1,
      currentTime: new Date(),
    };
  },
  computed: {
    deadline() {
      const date = new Date(this.created);
      date.setHours(date.getHours() + this.metaDeadline.lifetime);
      return date;
    },
    minuteRemaining() {
      return parseInt(
        (this.deadline.getTime() - this.currentTime.getTime()) / (1000 * 60)
      );
    },
    alertColor() {
      const hours = this.minuteRemaining / 60;

      for (const block of this.metaDeadline.stages) {
        if (hours < block.lifetime) {
          return block.color;
        }
      }

      return null;
    },
    remainingText() {
      const hours = parseInt(this.minuteRemaining / 60);
      const minutes = this.minuteRemaining % 60;
      return `${String(hours).padStart(2, "0")}h ${String(minutes).padStart(
        2,
        "0"
      )}m remaining`;
    },
  },
  mounted() {
    if (this.metaDeadline.countdown) {
      this.counterId = setInterval(() => {
        this.currentTime = new Date();
      }, 60 * 1000);
    }
  },
  beforeDestroy() {
    clearInterval(this.counterId);
  },
};
</script>

<style>
.circle-icon {
  display: inline-block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
}

.time-response-alert .tooltip-content {
  width: auto !important;
}
</style>
